import { reactive } from 'vue'
import axios from 'axios'
import { StoreBase } from '@/stores/StoreBase'
import { minBy } from 'lodash'
import { OrganizationDetail } from './LoginStoreTypes'

class LoginStore implements StoreBase {
  /* eslint-disable class-methods-use-this */
  createStore() {
    const state = reactive({
      loginId: '',
      loginName: '',
      displayName: '',
      accessToken: '',
      refreshToken: '',
      orgId: '',
      orgDetail: null as OrganizationDetail,
      mailAddress: '',
      registMethod: null as 'SNS_LINE' | 'MAIL_ADDRESS' | 'URL' | null,
    })

    /**
     * Login成功時に取得した返り値でstateを更新する
     * @param data ログイン成功時のAPIの返り値
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const setLoginState = (data: any) => {
      state.displayName = data.displayName
      // eslint-disable-next-line no-underscore-dangle
      state.loginId = data._id
      state.accessToken = data.access_token
      state.refreshToken = data.refresh_token
      // eslint-disable-next-line no-underscore-dangle
      state.orgId = data._organization
      state.orgDetail = data.organizationDetail
      state.mailAddress = data.mailAddress
      state.registMethod = data.registMethod
    }

    return {
      /**
       * ログインされているかどうか
       */
      get isLogin() {
        return !!state.accessToken
      },
      /**
       * アクセストークン
       */
      get accessToken() {
        return state.accessToken
      },
      /**
       * 組織ID
       */
      get orgId() {
        return state.orgId
      },
      /**
       * ログインしたユーザーID
       */
      get loginId() {
        return state.loginId
      },
      /**
       * ログインユーザーの表示名
       * @constructor
       */
      get name() {
        return state.displayName || state.loginName
      },
      /**
       * メールアドレス
       */
      get mailAddress() {
        return state.mailAddress
      },
      /**
       * 登録方法
       */
      get registMethod() {
        return state.registMethod
      },
      /**
       * ユーザー名とパスワードを用いてログイン処理を行う
       * @param loginName ログイン名
       * @param password パスワード
       */
      async login(loginName: string, password: string) {
        const url = process.env.VUE_APP_API_BASE_URL as string
        let isSuccess = false
        const name = encodeURIComponent(loginName)
        const pass = encodeURIComponent(password)
        try {
          const response = await axios({
            method: 'post',
            url: `${url}/auth`,
            data: `grant_type=password&username=${name}&password=${pass}`,
            headers: {
              Accept: 'application/json',
              'Content-type': 'application/x-www-form-urlencoded',
            },
          })
          if (response.status === 200) {
            isSuccess = true
            /* eslint-disable no-underscore-dangle */
            state.loginName = loginName
            setLoginState(response.data)
          }
        } catch (e) {
          if (e.response.status === 409) {
            const organizations = e.response.data.details as [
              { target: string; message: string; userCreatedDate: number },
            ]
            const homeOrganization = minBy(organizations, org => org.userCreatedDate)
            if (homeOrganization) {
              try {
                const response = await axios({
                  method: 'post',
                  url: `${url}/${homeOrganization.target}/auth`,
                  data: `grant_type=password&username=${name}&password=${pass}`,
                  headers: {
                    Accept: 'application/json',
                    'Content-type': 'application/x-www-form-urlencoded',
                  },
                })
                if (response.status === 200) {
                  isSuccess = true
                  /* eslint-disable no-underscore-dangle */
                  state.loginName = loginName
                  setLoginState(response.data)
                }
              } catch (orgLoginError) {
                console.error(orgLoginError)
              }
            }
          } else {
            console.error(e)
          }
        }
        return {
          isSuccess,
        }
      },
      setLoginState,
    }
  }
}

export default new LoginStore().createStore()
